// Pure decision logic for the pull-to-refresh gesture, split out of the
// component so it's unit-testable without a DOM. See components/pull-to-refresh.

/**
 * Should the pull gesture RELEASE (stop owning the touch)? Pull-to-refresh may
 * only hijack a move while the scroller is genuinely at the top AND the finger
 * is still pulling down. The bug this guards against: the old code latched
 * ownership at touchstart and only checked `dy <= 0`, so a single continuous
 * gesture that started at the top, scrolled the page down, then reversed would
 * stay latched and `preventDefault` the upward scroll, the page got "stuck"
 * until a refresh. Re-checking `scrollTop` here releases the instant we leave
 * the top, so native scrolling is never blocked.
 *
 * @param dy         finger delta from gesture start (px); positive = pulled down
 * @param scrollTop  the scroll container's current scrollTop
 */
export function shouldReleasePull(dy: number, scrollTop: number): boolean {
  return dy <= 0 || scrollTop > 0;
}
